export const PROPERTIES = {
    ENV: {
        BASE_URL: process.env.API_URL,
        API_PATH: process.env.API_PATH
    }
};